import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { EventTypes } from 'src/app/core/constants/event-types';
import { LoggerService } from 'src/app/core/services/logger.service';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';


@Component({
    selector: 'app-delete-contact-by-cellphone',
    templateUrl: './delete-contact-by-cellphone.component.html',
    imports: [BaseIndexModule, ReactiveFormsModule]
})

export class DeleteContactByCellPhoneComponent {

  phonebookIds;

  @Input() form: any;
  @Input() model: any = {};
  @Output("phonebookIdsModel") phonebookIdsModel: any = new EventEmitter<Array<number>>();

  constructor(private loggerService: LoggerService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes["model"]) {
        this.phonebookIds = [];
        this.emitPhonebookIds(this.phonebookIds);
      }
    } catch (error) {
      this.loggerService.logError('app-delete-contact-by-cellphone', error, EventTypes.facility)
    }



  }

  emitPhonebookIds(ids) {
    this.phonebookIds = ids;
    this.phonebookIdsModel.emit(this.phonebookIds);
  }


}
